import { forwardRef } from "react"
import type * as Polymorphic from "@radix-ui/react-polymorphic"
import { StyledLoader } from "./Loader"
import { FullScreenFlex } from "../Flex"
import { fullPageLoader } from "./styles/fullPageLoaderStyles"

type LoaderComponent = Polymorphic.ForwardRefComponent<"div">

export const FullPageLoader = forwardRef((props, forwardedRef) => (
  <FullScreenFlex css={fullPageLoader} ref={forwardedRef} {...props}>
    <StyledLoader />
  </FullScreenFlex>
)) as LoaderComponent
